import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import 'leaflet/dist/leaflet.css';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
import './index.css';
import './i18n';
import App from './App.tsx';
import ErrorBoundary from './ErrorBoundary.tsx';
import { RootRedirect, LangLayout } from './components/layout';
import { AuthProvider } from './auth';
import { UserRacesProvider } from './context/UserRacesContext';
import { LegalPage } from './pages/LegalPage';
import { MyRacesPage } from './pages/MyRacesPage';
import { ProfilePage } from './pages/ProfilePage';
import { RaceDetailPage } from './pages/RaceDetailPage';
import { RequireAuth } from './components/RequireAuth';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      {/* Suspense is required because i18n uses useSuspense: true (HttpBackend) */}
      <Suspense fallback={<div className="loading">Loading…</div>}>
        <BrowserRouter>
          <AuthProvider>
            <UserRacesProvider>
              <Routes>
                {/* Language-prefixed routes: /ko/* and /en/* */}
                <Route path="/:lang/*" element={<LangLayout />}>
                  <Route path="privacy" element={<LegalPage doc="privacy" />} />
                  <Route path="terms" element={<LegalPage doc="terms" />} />
                  <Route path="my-races" element={<MyRacesPage />} />
                  <Route
                    path="profile"
                    element={
                      <RequireAuth>
                        <ProfilePage />
                      </RequireAuth>
                    }
                  />
                  <Route path="races/:id" element={<RaceDetailPage />} />
                  <Route path="*" element={<App />} />
                </Route>
                {/* Root redirect: detect language and redirect to /ko or /en */}
                <Route path="/" element={<RootRedirect />} />
              </Routes>
            </UserRacesProvider>
          </AuthProvider>
        </BrowserRouter>
      </Suspense>
    </ErrorBoundary>
  </StrictMode>,
);
